import { useState } from 'react'
import { useMutation } from '@apollo/client/react'
import { Modal, Button, Group, Stack, Text, TextInput, Alert } from '@mantine/core'
import { IconCheck, IconAlertCircle } from '@tabler/icons-react'
import ResetPassword from '../graphql/queries/ResetPassword'
import { emailIsValid } from '../util/validation'

export default function ForgotPasswordModal({ opened, onClose, ...props }) {
    const [email, setEmail] = useState(() => localStorage.getItem('email') || '')
    const [emailSent, setEmailSent] = useState(false)
    const [message, setMessage] = useState('')
    const [messageType, setMessageType] = useState('error') // 'error' or 'success'

    const [resetPasswordMutation, { loading }] = useMutation(ResetPassword)

    function emailUpdated(e) {
        setMessage('')
        setEmail(e.target.value)
    }

    async function sendResetEmail() {
        // Validate email
        if (!emailIsValid(email)) {
            setMessage('Please enter a valid email address.')
            setMessageType('error')
            return
        }

        try {
            const response = await resetPasswordMutation({
                variables: { email }
            })

            if (response.data?.resetPassword) {
                setEmailSent(true)
                setMessage('If an account with that email address exists we sent a password reset link.  Check your inbox for instructions on how to reset your password.')
                setMessageType('success')
            } else {
                setMessage('Failed to send password reset email. Please try again.')
                setMessageType('error')
            }
        } catch (err) {
            console.error('Reset password error:', err)
            setMessage(err.message || 'An error occurred. Please try again.')
            setMessageType('error')
        }
    }

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Forgot Password"
            centered
            {...props}
        >
            <Stack gap="md">
                <Text size="sm" style={{ marginTop: '1em' }}>
                    Enter your email address and we'll send you a link to reset your password.
                </Text>

                <TextInput
                    label="Email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={emailUpdated}
                    type="email"
                    disabled={emailSent}
                />

                {message && (
                    <Alert
                        color={messageType === 'success' ? 'green' : 'red'}
                        variant="light"
                        icon={messageType === 'success' ? <IconCheck size={16} /> : <IconAlertCircle size={16} />}
                    >
                        {message}
                    </Alert>
                )}

                <Group justify="flex-end" mt="xs">
                    <Button
                        variant="default"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={loading || emailSent}
                        loading={loading}
                        onClick={sendResetEmail}
                    >
                        Send Reset Link
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}

